import apiClient from '../apiClient';
import { GET_EXCURSION_URL } from '../apiUrl';

const getExcursionListApi = id => {
  return apiClient.get(GET_EXCURSION_URL(id));
};

export default getExcursionListApi;
